module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/package/package-with-product/package-with-product.component.css
// module id = ./src/app/components/package/package-with-product/package-with-product.component.css
// module chunks = main